import routes from './module/routes';
import store from './module/store';

export default {
  name: 'login-static-plans',
  routes,
  store,
  requires: ['api', 'auth'],
};
